import { combineReducers } from 'redux-immutable';
import perspectivesReducer from './perspectives';
import searchContainerReducer from './SearchContainer';
const store = combineReducers({
  perspectives: perspectivesReducer,
  searchContainer: searchContainerReducer
});
export default store;